import { Text } from '@pancakeswap/uikit'
import { TVL_HINT, formatTvl } from 'utils/formatTvl'

/**
 * "TVL $x" under a farm's APR where the row has no Staked Liquidity column (phones and narrow screens; site review 59 #5): the staked,
 * in-range liquidity the APR is computed from. Unknown is a dash.
 */
export default function FarmTvl({ usd }: { usd: number | string | null | undefined }) {
  const n = usd === null || usd === undefined || usd === '' ? null : Number(usd)
  return (
    <Text fontSize="12px" color="textSubtle" title={TVL_HINT} data-testid="farm-tvl" style={{ whiteSpace: 'nowrap' }} mt="2px">
      {formatTvl(n !== null && Number.isFinite(n) ? n : null)}
    </Text>
  )
}
